export const pianoErrorCodes = {
  invalidPasswordError: 1419,
  passwordLessLoginError: 1434,
  userExistsError: 1213,
};
